import React from "react";
import { ViewContainerFabric } from "@msidentity/SISU/components/view-container/fabric/view-container-fabric";
import { FlowId, ViewId } from "@msidentity/sisu/constants/routing-constants";
import { MicrosoftChallengeBlockLearnMore } from "@msidentity/SISU/constants/url-constants";
import { useDocumentTitle, useNavigateBack } from "@msidentity/SISU/hooks";
import { useActivateView } from "@msidentity/sisu/hooks/use-activate-view";
import {
  usernameRecoveryBlockedViewStringsFabric as viewStrings,
  usernameRecoveryGenericStringsFabric as flowStrings,
} from "../../../fabric/username-recovery-strings-fabric";

const { title, description } = viewStrings;

/**
 * Blocked page for the Username Recovery flow
 * @returns instance of the component
 */
export const UsernameRecoveryBlockedViewFabric: React.FC =
  function UsernameRecoveryBlockedViewFabric() {
    useActivateView(ViewId.UsernameRecoveryBlocked, FlowId.UsernameRecovery, {
      showBackButtonOnActiveView: false,
      showIdentityBanner: false,
    });
    useDocumentTitle(title);

    const navigateBack = useNavigateBack();

    return (
      <ViewContainerFabric
        applyAriaLive
        title={{
          title,
        }}
        description={{
          description,
        }}
        secondaryButton={{
          label: flowStrings.back,
          onClick: navigateBack,
        }}
      >
        <div>
          <a href={MicrosoftChallengeBlockLearnMore} target="_blank" rel="noreferrer noopener">
            {flowStrings.learnMore}
          </a>
        </div>
      </ViewContainerFabric>
    );
  };
